export const currentLocation = state =>
  state.currentLocation

export const reportedLocations = state =>
  state.reportedLocations



// WEBPACK FOOTER //
// ./src/store/locations/getters.js